import { Route, Routes } from "react-router-dom";
import { lazy, Suspense } from "react";
import Layout from "@/app/Layout";
import HomePage from "@/app/HomePage";
import NotFoundPage from "@/app/NotFoundPage";
import RecipeListPage from "@/features/recipe/RecipeListPage";
import RecipeDetailPage from "@/features/recipe/RecipeDetailPage";
import ProcessBrowserPage from "@/features/process-browser/ProcessBrowserPage";
import PrivacyPage from "@/features/legal/PrivacyPage";
import TermsPage from "@/features/legal/TermsPage";
import TrademarkPage from "@/features/legal/TrademarkPage";
import ReportPage from "@/features/legal/ReportPage";
import AboutPage from "@/features/legal/AboutPage";

const SearchPage = lazy(() => import("@/features/search/SearchPage"));
const MapPage = lazy(() => import("@/features/process-map/MapPage"));
const AdminHome = lazy(() => import("@/features/admin/AdminHome"));
const AdminSignInPage = lazy(() => import("@/features/admin/AdminSignInPage"));
const RecipeEditorPage = lazy(() => import("@/features/admin/RecipeEditorPage"));
const TaxonomyEditorPage = lazy(() => import("@/features/admin/TaxonomyEditorPage"));
const RequireAdmin = lazy(() => import("@/features/admin/RequireAdmin"));

function Loading() {
  return (
    <p className="text-slate-500" aria-live="polite">
      Loading…
    </p>
  );
}

export default function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/processes/*" element={<ProcessBrowserPage />} />
        <Route path="/recipes" element={<RecipeListPage />} />
        <Route path="/recipes/:id" element={<RecipeDetailPage />} />
        <Route
          path="/search"
          element={
            <Suspense fallback={<Loading />}>
              <SearchPage />
            </Suspense>
          }
        />
        <Route
          path="/map"
          element={
            <Suspense fallback={<Loading />}>
              <MapPage />
            </Suspense>
          }
        />
        <Route
          path="/map/*"
          element={
            <Suspense fallback={<Loading />}>
              <MapPage />
            </Suspense>
          }
        />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/trademark" element={<TrademarkPage />} />
        <Route path="/report" element={<ReportPage />} />
        <Route
          path="/admin/sign-in"
          element={
            <Suspense fallback={<Loading />}>
              <AdminSignInPage />
            </Suspense>
          }
        />
        <Route
          path="/admin"
          element={
            <Suspense fallback={<Loading />}>
              <RequireAdmin>
                <AdminHome />
              </RequireAdmin>
            </Suspense>
          }
        />
        <Route
          path="/admin/recipes/new"
          element={
            <Suspense fallback={<Loading />}>
              <RequireAdmin>
                <RecipeEditorPage />
              </RequireAdmin>
            </Suspense>
          }
        />
        <Route
          path="/admin/taxonomy"
          element={
            <Suspense fallback={<Loading />}>
              <RequireAdmin>
                <TaxonomyEditorPage />
              </RequireAdmin>
            </Suspense>
          }
        />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  );
}
